<template>
  <section :id="`page-${sectionName}`" class="page-section w-100">
    <fade-shift>
      <slot name="header" v-bind:content="content" />
      <div :class="wrapperClass">
        <div class="page-section-content container mx-auto px-6">
          <slot v-bind:content="content">
            <h2>{{ content.title }}</h2>
            <p
              v-for="(string, index) in content.body"
              :key="`${sectionName}-${index}`"
              v-html="string"
            />
          </slot>
        </div>
      </div>
      <slot name="footer" v-bind:content="content" />
    </fade-shift>
  </section>
</template>

<script>
export default {
  name: "PageSection",
  components: {
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    wrapperClass: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
